exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".signup-button{border:none;border-radius:2px;background-color:#173031;color:#fff!important;font-weight:500;text-transform:uppercase;width:150px;height:80%;display:-ms-flexbox;display:flex;left:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;transition:background-color .3s ease}.signup-button .hidden{display:none}.signup-button:active,.signup-button:focus{background:#2c5c5e}.signup-button:hover{background:#2c5c5e!important}@media screen and (min-width:480px){.signup-button{font-size:1.3rem}}@media screen and (min-width:900px){.signup-button{font-size:1.6rem}}@media screen and (min-width:1900px){.signup-button{font-size:1.6rem}}@media screen and (max-width:420px){.signup-button{font-size:1.2rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/signupbutton/signupbutton.styl
// module id = 513
// module chunks = 0